import React from "react";

interface ControlFactorProps {
  children: React.ReactNode;
  isSelected: boolean;
}

export const ControlFactor: React.FC<ControlFactorProps> = ({
  children,
  isSelected,
}) => {
  return (
    <div
      style={{
        opacity: isSelected ? 1 : 0,
        pointerEvents: isSelected ? "auto" : "none",
        transition: "all 0.2s ease-in-out",
        bottom: isSelected ? "48px" : "24px",
      }}
      className="absolute flex justify-center items-center bg-[var(--white)] gap-1 rounded-xl w-[240px] shadow-[rgba(0,_0,_0,_0.05)_0px_0px_12px]"
    >
      {children}
    </div>
  );
};
